import { Typography, alpha, styled } from "@mui/material";
import { DYNAMIC_BASE_URL } from "shared/enum";
import { palette } from "./InteractionGuide";

type CarouselItemProps = {
  title: string;
  description: string;
};

export default function CarouselItem({ item }: { item: CarouselItemProps }) {
  const { title, description } = item;
  return (
    <CarouselItemContainer>
      <img src={`${DYNAMIC_BASE_URL}/resources/turn.png`} alt="360" />
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2" sx={{ lineHeight: "1.2em", mt: "0.5em" }} textAlign="center">
        {description}
      </Typography>
    </CarouselItemContainer>
  );
}

const CarouselItemContainer = styled("div")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 0.8,
  background: alpha(palette.backgroundPaper, 0.85),
  boxShadow: "0 5px 10px rgba(0,0,0,0.3)",
  padding: "0 20px 20px 20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "80%",
  margin: "15px",
}));
